import { appGetState } from 'legacy/lut/store'

import { getTokens } from 'core/classes/helpers/StorageHelper'
import { proxy } from 'core/classes/helpers/UrlHelper'
import { HttpHeaders, Rest } from 'core/classes/http'
import { ActualsValueTypes } from 'partner360/models/actualValueTypes'

import { ISPJBPResponse } from './models/ISPJBPResponse'

export const applyJBPPlanning = async <T>(
  partnerId: string,
  fYear: number,
  fromFYear: number,
  programType: string,
  isQuarterPlanning: boolean,

  isUSD: boolean,
  actualsType: ActualsValueTypes,
  isRegionalDistributor: boolean,
  json: string
): Promise<ISPJBPResponse<T>> => {
  const url = proxy('/webservice/621/sp/v3/spJBPPlanningApplyChanges/call')

  const payload = {
    'p.PartnerId': partnerId,
    'p.FYear': fYear,
    'p.FYearFrom': fromFYear,
    'p.ProgramType': programType,
    'p.IsQuarterPlanning': isQuarterPlanning ? 1 : 0,
    'p.IsShipment': 0,
    'p.IsUSD': isUSD ? 1 : 0,
    'p.ActualsType': actualsType,
    'p.isRegionalDistributor': isRegionalDistributor ? 1 : undefined,
    'p.Planning': json,
  }

  const { app } = appGetState()
  const [accessToken] = await getTokens(app.ownerId)

  const headers = new HttpHeaders()
  if (accessToken) {
    headers.add('Authorization', `Bearer ${accessToken}`)
  }

  const response = await Rest.post({ url, payload, headers })

  return response
}
